import { render, staticRenderFns } from "./abstract-course-card.vue?vue&type=template&id=3e06a016"
import script from "./abstract-course-card.vue?vue&type=script&lang=js"
export * from "./abstract-course-card.vue?vue&type=script&lang=js"
import style0 from "./abstract-course-card.vue?vue&type=style&index=0&id=3e06a016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports